import { Role } from 'states';

// Only a Super Admin may grant the Super Admin scope to another user, or edit
// a role - an Admin creating/editing a user must never see Super Admin as a
// selectable option, and must never see the Edit role control.
export const isSuperAdminRoleCode = (r?: Role) => r?.superAdmin === true || r?.code === 'SUPER_ADMIN';
